import { Injectable } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { TextEditorHistoryService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-history.service';
import { TextEditorInsertLinkService } from '@fi-shared/fi-text-editor/fi-text-editor-insert-link/text-editor-insert-link.service';
import { FiInsertMedia2Service } from '@fi-shared/fi-insert-media/fi-insert-media2.service';
import { ObjectTypes } from '@fi-shared/types';
import { FiLinkToType } from '@fi-shared/fi-text-item-helper/fi-link-to-type';
import { ITextPanelButton, TextPanelMenuTypes } from '@fi-shared/fi-text-panel/simple-text-panel/text-panel-base';
import { TextEditorInsertMediaService } from '@fi-shared/text-editor/text-editor-insert-media.service';
import { TextEditorInsertEmbedCodeService } from '@fi-shared/text-editor/text-editor-insert-embed-code.service';
import { LinkToTypesService } from '@fi-shared/link-to/link-to-types.service';
import { ITextEditorActiveButtons } from '@fi-shared/fi-text-editor/fi-text-editor';
import { findClosest } from '@fi-shared/utils';
import { FiContenteditableService } from '@fi-shared/fi-contenteditable/fi-contenteditable.service';

@Injectable()
export class AdvancedTextPanelMediaLinkService {
    constructor(
        private appTextService: AppTextService,
        private textEditorHistoryService: TextEditorHistoryService,
        private textEditorInsertMediaService: TextEditorInsertMediaService,
        private textEditorInsertLinkService: TextEditorInsertLinkService,
        private textEditorInsertEmbedCodeService: TextEditorInsertEmbedCodeService,
        private insertMedia2Service: FiInsertMedia2Service,
        private linkToTypesService: LinkToTypesService,
        private fiContenteditableService: FiContenteditableService,
    ) {}

    private textEditorActiveButtons: ITextEditorActiveButtons = {};
    setTextEditorActiveButtons(value: ITextEditorActiveButtons) {
        this.textEditorActiveButtons = { ...this.textEditorActiveButtons, ...value };
    }

    getButtons(objectType: ObjectTypes, isInternalLinksAllowed: boolean = true): ITextPanelButton[] {
        return [
            {
                title: this.appTextService.get('text_editor.insert_file'),
                class: 'far fa-image',
                btnClass: 'mobile-basic BrandedColorHover panel-icon-button',
                callback: () => {
                    const el = this.textEditorHistoryService.getElement();
                    if (el) {
                        const selection = document.getSelection();
                        const range = this.textEditorInsertMediaService
                            .getRangeForMediaInsert(el, selection)
                            .cloneRange();
                        const overlay = this.insertMedia2Service.openInsertMediaDialogWithFileSizes(objectType);
                        this.textEditorActiveButtons.attachments = true;
                        /*overlay.opened.then(function ()
                        {
                            var onDestroy = scope.$on('$destroy', function ()
                            {
                                overlay.closeDialog();
                            });
                            overlay.closed.then(function ()
                            {
                                onDestroy();
                            })
                        });*/

                        overlay
                            .onYesButtonClick((result) => {
                                range.deleteContents();
                                this.textEditorInsertMediaService
                                    .createNodesFromResult(result.mediaBankFileReferences)
                                    .then((nodes) => {
                                        this.textEditorInsertMediaService.insertMediaIntoTextEditorRange(
                                            range,
                                            selection,
                                            nodes,
                                        );
                                    });
                            })
                            .afterClosed(() => (this.textEditorActiveButtons.attachments = false));
                    }
                },
                selected: () => this.textEditorActiveButtons.attachments,
            },
            {
                title: this.appTextService.get('text_editor.insert_link'),
                class: 'fas fa-link',
                btnClass: 'mobile-basic BrandedColorHover panel-icon-button',
                isMatMenu: true,
                matMenuTriggerButtonType: TextPanelMenuTypes.LinkAttachment,
                callback: (linkToType: FiLinkToType) => {
                    if (this.textEditorHistoryService.getElement()) {
                        this.textEditorActiveButtons.link = true;
                        this.textEditorInsertLinkService
                            .insertLink({
                                parentElement: this.textEditorHistoryService.getElement(),
                                linkToType,
                            })
                            .afterClosed(() => (this.textEditorActiveButtons.link = false));
                    }
                },
                menuItems: this.linkToTypesService.getAvailableLinkToItems(isInternalLinksAllowed),
                selected: () => this.textEditorActiveButtons.link,
            },
            {
                title: this.appTextService.get('text_editor.insert_embed_code'),
                class: 'fas fa-code',
                btnClass: 'BrandedColorHover panel-icon-button',
                callback: () => {
                    if (this.textEditorHistoryService.getElement())
                        this.textEditorInsertEmbedCodeService.insertEmbedCode(
                            this.textEditorHistoryService.getElement(),
                        );
                },
                selected: () => this.textEditorInsertEmbedCodeService.isDialogOpened,
            },
            {
                title: this.appTextService.get('text_editor.insert_table'),
                class: 'fas fa-table',
                btnClass: 'BrandedColorHover panel-icon-button',
                callback: () => {
                    const el = this.textEditorHistoryService.getElement();
                    const selection = document.getSelection();
                    const range = this.textEditorInsertMediaService.getRangeForMediaInsert(el, selection);
                    const tableElement = this.getTableElement();
                    range.insertNode(tableElement);
                },
                selected: () =>
                    !!findClosest(this.fiContenteditableService.getRangeStartElement(), 'table', '.text-editor'),
            },
        ];
    }

    private getTableElement(rows: number = 4, cols: number = 4): HTMLElement {
        const table = document.createElement('table');
        table.className = 'fi-table-element';
        table.setAttribute('fi-table-text-item', '');
        const tbody = document.createElement('tbody');
        for (let i = 0; i < rows; i++) {
            const tr = document.createElement('tr');
            for (let j = 0; j < cols; j++) {
                const td = document.createElement('td');
                td.appendChild(document.createTextNode(''));
                tr.appendChild(td);
            }
            tbody.appendChild(tr);
        }
        table.appendChild(tbody);
        return table;
    }
}
